export const CHECKOUT_URL = 'https://pawsy-companion.impultienda.ar/checkout/pawsy'

export const CTA_LABEL = "Build My Dog's Plan — $29"

export const guaranteeLine = '7-day money-back guarantee · One-time payment · No subscription'

export const trustLine = 'Instant access · One-time payment · No subscription'

export const painQuestions = [
  'How much should I feed him?',
  'Are these treats too much?',
  'Is my dog at a healthy weight?',
  'Can my dog eat this?',
  'Is he getting enough water?',
  'Am I actually feeding him correctly?',
]

export const howItWorks = [
  'Answer six quick questions',
  "Get your dog's personalized plan",
  'Use Pawsy every day',
]

export type Pillar = {
  emoji: string
  title: string
  body: string
  accent: string
}

export const pillars: Pillar[] = [
  {
    emoji: '🥣',
    title: 'Feed',
    body: 'Know what, when and how much to feed.',
    accent: 'bg-orangey-50',
  },
  {
    emoji: '🔍',
    title: 'Check',
    body: 'Get quick answers about food, weight and nutrition.',
    accent: 'bg-teal-50',
  },
  {
    emoji: '📚',
    title: 'Learn',
    body: 'Understand the basics without digging through endless advice.',
    accent: 'bg-orangey-50',
  },
  {
    emoji: '❤️',
    title: 'Care',
    body: 'Turn good intentions into simple daily habits.',
    accent: 'bg-teal-50',
  },
]

export type ReportRow = {
  emoji: string
  label: string
  status: string
  tone: 'good' | 'watch' | 'ok'
  detail: string
}

export const reportRows: ReportRow[] = [
  { emoji: '🍽️', label: 'Feeding Plan', status: 'On track', tone: 'good', detail: '742 kcal/day · 2 meals · 1⅓ cups' },
  { emoji: '💧', label: 'Hydration', status: 'Slightly low', tone: 'watch', detail: '640 ml logged of 780 ml target' },
  { emoji: '🍖', label: 'Treat Intake', status: 'Within budget', tone: 'good', detail: '52 kcal of 74 kcal treat limit' },
  { emoji: '⚖️', label: 'Weight', status: 'Ideal range', tone: 'ok', detail: '18.4 kg · body condition 5/9' },
]

export const recommendations = [
  'Add one extra water refill after the afternoon walk.',
  'Swap the evening biscuit for 3 blueberries — same reward, 40 fewer kcal.',
  'Weigh your dog again on Sunday to confirm the plan is holding.',
]

export const beforePawsy = [
  '“How much should I feed him?”',
  '“Is this food safe?”',
  '“Are these treats too much?”',
  '“Is my dog at a healthy weight?”',
  '“Am I actually doing this right?”',
]

export const withPawsy = [
  'Personalized feeding guidance',
  'Daily feeding schedule',
  'Safe food answers',
  'Weight & body condition guidance',
  'Clear recommendations',
  'Daily care tracking',
]

export const included = [
  'Personalized Nutrition Plan',
  'Pawsy Nutrition Check',
  'Safe Foods Checker',
  'Weight & Body Condition Tracking',
  'Feeding Schedule Planner',
  'Monthly Feeding Cost Calculator',
  '25 Pawsy Guides',
  'Daily Routine Checklist + Achievements',
]

export const whatYouGet = [
  { emoji: '🥣', label: 'Personalized Nutrition Plan' },
  { emoji: '🟢', label: 'Pawsy Nutrition Check' },
  { emoji: '🔍', label: 'Safe Foods Checker' },
  { emoji: '⚖️', label: 'Weight & Body Condition Tracking' },
  { emoji: '🗓️', label: 'Feeding Schedule Planner' },
  { emoji: '💰', label: 'Monthly Feeding Cost Calculator' },
  { emoji: '📚', label: '25 Pawsy Guides' },
  { emoji: '✅', label: 'Daily Routine Checklist + Achievements' },
]

export const faqs = [
  {
    question: 'Will this work for my breed?',
    answer:
      "Yes — Pawsy builds your dog's plan from their actual weight, age, activity level and goal, not breed averages, so it works for any breed or mixed breed.",
  },
  {
    question: 'Do I need to know anything about dog nutrition?',
    answer:
      'No. Answer six simple questions about your dog and Pawsy does the rest — in plain language, with clear next steps.',
  },
  {
    question: 'Is this a subscription?',
    answer:
      "No — it's a one-time $29 payment for lifetime access, backed by a 7-day money-back guarantee. No renewals, no hidden charges.",
  },
  {
    question: 'What if I have more than one dog?',
    answer: 'You can build and save a separate plan for each dog, so every one of them gets their own guidance.',
  },
  {
    question: 'How do I get access after I buy?',
    answer:
      "You'll get an access code by email right after checkout — enter it on the app's welcome screen to unlock everything. It works on any device, no install required.",
  },
  {
    question: 'Is Pawsy a replacement for my veterinarian?',
    answer:
      'No. Pawsy is an everyday nutrition and care guidance tool, not medical advice. It helps you make confident daily decisions — for health conditions, diagnoses or treatment, always talk to your veterinarian.',
  },
]

export const recipeStudioFeatures = [
  { emoji: '📖', label: '24 vet-informed recipes' },
  { emoji: '🗓️', label: 'Weekly Meal Planner' },
  { emoji: '🛒', label: 'Shopping List' },
  { emoji: '🍲', label: 'Batch Cooking Guide' },
  { emoji: '❄️', label: 'Freezer-friendly recipes' },
]

export const heroDogImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/3ed2c70c-db01-410a-b655-4ff904e7652f.jpg'

export const inActionImage =
  'https://cdn.magicpatterns.com/uploads/3QXkQBFaqzsT7sF5GhFZxx/ChatGPT_Image_13_ago_2026,_10_42_51_a.m..png'

export const recipeStudioImage =
  'https://cdn.magicpatterns.com/uploads/iDKVFHbGj435D2KHG9jSiq/ChatGPT_Image_5_ago_2026,_07_04_20_p.m..png'

export const appScreensImage =
  'https://cdn.magicpatterns.com/uploads/w2ERbnmdW2Lsr42JAxDkBU/ChatGPT_Image_5_ago_2026,_07_08_22_p.m..png'
